export default __webpack_public_path__ + "static/media/avatar.6167a1e3.svg";